module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/logo_123tv.png?65cf35055cd351e6625c401b5853fcc7";